import { isGlobalFeatureEnabled } from "owa-feature-flags";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";
import { shouldShowFolderPane } from "./shouldShowFolderPane";
import { shouldShowFolderPaneAsOverlay } from "./shouldShowFolderPaneAsOverlay";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getIsBitSet, type ListViewBitFlagsMasks } from "owa-bit-flags/lib/utils/listViewBitFlagsUtil";

export function shouldShowFavoritesSideRail(): boolean {
    // New collapsed-rail reopen affordance is gated to Win32 styling overlay.
    if (isWin32StylingEnabled() && !shouldShowFolderPane()) {
        return true;
    }
    
    // Legacy flight-gated behavior.
    return (isGlobalFeatureEnabled("fp-vertical-favorites") &&
        !getIsBitSet(16384, getGlobalSettingsAccountMailboxInfo()) &&
        (!shouldShowFolderPane() || shouldShowFolderPaneAsOverlay()));
}
